module.exports = __webpack_public_path__ + "static/media/home-banner-2.429110fc.png";